import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Zona } from '../interfaces/utilidades/zona.interface';
import { Campo } from '../interfaces/utilidades/campo.interface';

@Injectable({
  providedIn: 'root'
})
export class ZonaService {
  private apiUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/zona';

  constructor(private http: HttpClient) {}

  getZonas(): Observable<Zona[]> {
    return this.http.get<Zona[]>(this.apiUrl);
  }

  getZonaById(id: number): Observable<Zona> {
    return this.http.get<Zona>(`${this.apiUrl}/${id}`);
  }

  createZona(zona: Zona): Observable<Zona> {
    return this.http.post<Zona>(this.apiUrl, zona);
  }

  updateZona(zona: Zona): Observable<Zona> {
    return this.http.put<Zona>(`${this.apiUrl}/${zona.id_zona}`, zona);
  }

  deleteZona(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  getCamposByZona(zonaId: number): Observable<Campo[]> {
    return this.http.get<Campo[]>(`${this.apiUrl}/${zonaId}/campos`);
  }

}
